import * as React from "react";
import { singleton } from "logic/singleton";
const OverflowingComponentsContext = React.createContext(null);
export default singleton("contexts.OverflowingComponentsContext", () => OverflowingComponentsContext);
